import React from 'react'
import PropTypes from 'prop-types'
import { cn } from 'twyne-new.ui'

const DropzonePropTypes = {
  dropReference: PropTypes.func,
  thresholdConfig: PropTypes.object,
  isOver: PropTypes.bool
}
export default function Dropzone({ path, id, dropReference, thresholdConfig, isOver, feedback }) {
  const _feedback = feedback === false ? false : true

  return <div ref={dropReference} className={thresholdConfig}>
    {_feedback &&
      <div className={cn(isOver && 'h-1 w-full rounded-sm twy-bg-accent mx-4')}>
        {/* {`p: ${path}, i: ${id}`} */}
      </div>
    }
  </div>
}

Dropzone.propTypes = DropzonePropTypes
